var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{staticClass:"hidden-print",attrs:{"value":_vm.overlay}},[_c('v-progress-circular',{attrs:{"value":"5","indeterminate":"","rotate":"100","size":"100","width":"2"}}),_c('span',{staticStyle:{"background-color":"#2d2b2b"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }